export default __webpack_public_path__ + "static/media/ic_atention.da808097.svg";